import { Sms1 } from "../../../../src/components/images/support/users/Sms1.generated";
import { Sms2 } from "../../../../src/components/images/support/users/Sms2.generated";
import { Sms3 } from "../../../../src/components/images/support/users/Sms3.generated";
import * as React from 'react';
export default {
  Sms1,
  Sms2,
  Sms3,
  React
};